var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camera",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.593,
    height: 24.833,
    viewBox: "0 0 27.593 24.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M1.587,9.577A5.424,5.424,0,0,1,0,5.746,5.34,5.34,0,0,1,1.573,1.928a5.417,5.417,0,1,1,.014,7.649ZM3.036,3.39A3.22,3.22,0,0,0,2.07,5.733v.014A3.343,3.343,0,0,0,5.423,9.1,3.371,3.371,0,0,0,8.775,5.746,3.357,3.357,0,0,0,3.036,3.39ZM11.92,1.254a1.249,1.249,0,1,1,1.242,1.24A1.248,1.248,0,0,1,11.92,1.254Z",
    transform: "translate(8.374 8.503)",
    fill: "#1877f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M21.3,4.465l-.138-.3c-.372-.786-.8-1.7-1.062-2.219A3.369,3.369,0,0,0,17.038,0h-6.5A3.349,3.349,0,0,0,7.491,1.943C7.215,2.494,6.746,3.487,6.36,4.3l-.083.165a.271.271,0,0,1-.262.165A6.017,6.017,0,0,0,0,10.639v8.186a6.017,6.017,0,0,0,6.015,6.008H21.577a6.026,6.026,0,0,0,6.015-6.008V10.639A6.026,6.026,0,0,0,21.577,4.63.314.314,0,0,1,21.3,4.465Z",
    fill: "#1877f2",
    opacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCameraIcon);
export default __webpack_public_path__ + "static/media/menu_cameraIcon.807031be78e71d6694264ab2513e8183.svg";
export { ForwardRef as ReactComponent };